module.exports = __webpack_public_path__ + "static/img/member231228EN.9076194.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member231228EN.jpg
// module id = oY7z
// module chunks = 1